<template>

  <div>

    Sign in form

    <el-form ref="form" :model="form" label-width="120px">
      <el-form-item label="Username">
        <el-input v-model="form.username" @keyup.enter.native="loginUser"></el-input>
      </el-form-item>
      <el-form-item label="Password">
        <el-input v-model="form.password" type="password" @keyup.enter.native="loginUser"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="loginUser">Login</el-button>
      </el-form-item>
    </el-form>

    <a href="/auth/facebook">Login with Facebook</a>
    <a href="/auth/google">Sign In with Google</a>
  </div>

</template>

<script>
import axios from '../store/my-axios';

export default {
  data() {
    return {
      form: {}
    };
  },
  methods: {
    async loginUser() {
      console.info(this.form);

      const res = await axios.post('/v1/auth', this.form);
      console.info(res);
    }
  }
};
</script>



// WEBPACK FOOTER //
// Signin.vue?7bb265c3